import { TEMP_IMAGE_URL } from "~/shared/ui/EmptyImagePlaceholder";

export async function generateTempImageFile(): Promise<File> {
  const res = await fetch(TEMP_IMAGE_URL);
  const blob = await res.blob();
  return new File([blob], "temp_image.png", { type: "image/png" });
}
